export const careerProfile = {
  sectionTitle: 'Professional Summary',
  icon: null,
  description: [
    'Senior Product & AI Systems Engineer with 10+ years of experience designing and shipping production-grade systems across SaaS, cloud environments, and AI-powered platforms.',
    'Specialized in LLM orchestration, RAG architectures, and distributed async pipelines, with full ownership from system design to deployment and operations.',
    'Strong product mindset, translating business requirements into scalable, reliable AI systems that move from ingestion and indexing to inference and delivery.'
  ].map((p) => `<p>${p}</p>`).join('')
};

export default careerProfile;



// WEBPACK FOOTER //
// ./src/data/careerProfile.js